import { ENGINE_VERSION, ProjectSchema, type Project } from "@tasduvar/engine";
import { LocalStorageProjectStore } from "./localStorageStore";
import { MemoryProjectStore } from "./memoryStore";
import { ApiProjectStore } from "./apiStore";
import type { ProjectStore } from "./types";

export * from "./types";
export { LocalStorageProjectStore, MemoryProjectStore, ApiProjectStore };
export { ConflictError } from "./apiStore";

function hasLocalStorage(): boolean { try { const k = "__t"; window.localStorage.setItem(k, "1"); window.localStorage.removeItem(k); return true; } catch { return false; } }
/** Bu cihazdaki taslaklar (v1.0 davranışı; misafir modu). */
export const projectStore: ProjectStore = typeof window !== "undefined" && hasLocalStorage() ? new LocalStorageProjectStore() : new MemoryProjectStore();
/** Bulut projeleri (oturum açıkken). */
export const cloudStore = new ApiProjectStore();

export type ProjectOrigin = "local" | "cloud" | "shared";
export const storeFor = (origin: ProjectOrigin): ProjectStore => (origin === "cloud" ? cloudStore : projectStore);

/** Oturum açıksa önce bulut, sonra yerel; kökenini de döner. */
export async function loadAnyProject(id: string, cloudFirst: boolean): Promise<{ project: Project; origin: ProjectOrigin } | null> {
  if (cloudFirst) {
    try { const p = await cloudStore.load(id); if (p) return { project: p, origin: "cloud" }; } catch { /* API yoksa yerel */ }
  }
  const p = await projectStore.load(id);
  return p ? { project: p, origin: "local" } : null;
}

export const PROJECT_FILE_APP = { name: "tasduvar", engineVersion: ENGINE_VERSION } as const;
export function toProjectFile(p: Project): { app: typeof PROJECT_FILE_APP } & Project { return { app: PROJECT_FILE_APP, ...p }; }
export function fromProjectFile(raw: unknown): Project {
  const r = ProjectSchema.safeParse(raw);
  if (!r.success) throw new Error("Proje dosyası okunamadı: " + r.error.issues.slice(0, 3).map((i) => i.path.join(".") + " " + i.message).join("; "));
  return r.data;
}
export function projectFileName(p: Project): string {
  const slug = p.info.name.toLocaleLowerCase("tr").replace(/ı/g, "i").replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ş/g, "s").replace(/ö/g, "o").replace(/ç/g, "c").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "proje";
  return `${slug}.tasduvar.json`;
}
